import React from 'react';
import { Link } from 'react-router-dom';
import { companyData } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[#f6f9fb] text-[#1a365d] py-16 px-6 border-t border-gray-200">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <img
              src={companyData.logo}
              alt="Berkshire Investment Group Inc."
              className="w-56 h-auto object-contain mb-5"
            />
            <p className="text-gray-600 text-sm leading-relaxed max-w-md mb-4">
              A permanent-capital industrial, infrastructure and investment platform connecting Africa's most important economic opportunities with American capital, technology and corporations.
            </p>
            <p className="text-xs text-gray-500">Strategic period 2026 – 2046</p>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#2f9e8e] mb-4">The Strategy</h4>
            <ul className="space-y-2">
              <li><Link to="/strategy/platforms" className="text-gray-600 hover:text-[#1a365d] text-sm" data-testid="footer-link-platforms">Eight Platforms</Link></li>
              <li><Link to="/strategy/capital" className="text-gray-600 hover:text-[#1a365d] text-sm" data-testid="footer-link-capital">Capital Architecture</Link></li>
              <li><Link to="/strategy/roadmap" className="text-gray-600 hover:text-[#1a365d] text-sm" data-testid="footer-link-roadmap">20-Year Roadmap</Link></li>
              <li><Link to="/strategy/teaser" className="text-[#2f9e8e] hover:text-[#1a365d] text-sm font-medium" data-testid="footer-link-teaser">Download Briefing Pack →</Link></li>
              <li><Link to="/leadership" className="text-gray-600 hover:text-[#1a365d] text-sm" data-testid="footer-link-leadership">Leadership & Governance</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#2f9e8e] mb-4">Sub-platforms</h4>
            <ul className="space-y-2">
              <li><Link to="/africa" className="text-gray-600 hover:text-[#1a365d] text-sm" data-testid="footer-link-africa">Berkshire Africa Special Situations</Link></li>
              <li><Link to="/institutional" className="text-gray-600 hover:text-[#1a365d] text-sm" data-testid="footer-link-institutional">Institutional Capital Partnership</Link></li>
            </ul>
            <h4 className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#2f9e8e] mt-6 mb-3">Engage</h4>
            <ul className="space-y-2">
              <li><a href="/#engage" className="text-gray-600 hover:text-[#1a365d] text-sm" data-testid="footer-link-engage">Capital · Sovereign · U.S. Corporate</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#2f9e8e] mb-4">Contact</h4>
            <a
              href={`mailto:${companyData.contactEmail}`}
              className="text-[#2f9e8e] hover:text-[#1a365d] text-sm block mb-3"
            >
              {companyData.contactEmail}
            </a>
            <p className="text-xs text-gray-500 leading-relaxed">
              Briefing packs are tailored to audience and jurisdiction.
            </p>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-12 pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-gray-500 text-xs">
            © {new Date().getFullYear()} Berkshire Investment Group Inc. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs max-w-3xl md:text-right" data-testid="footer-disclaimer">
            The content on this website is provided for general informational purposes only. It does not constitute an offer or solicitation of securities, investment, legal or tax advice, a commitment of capital, or a guarantee of investment performance. Forward-looking statements involve assumptions and uncertainties and actual outcomes may differ materially.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
